import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/GlobalProvider";
import { Dashboard_Profile } from "../../assets/data/Imagedata";
import { useEffect, useState } from "react";
import { FETCH_Users, user_referral_level_one } from "../../hooks/APIHooks";
import { IoLockClosed, IoLockOpen } from "react-icons/io5";
import LogoLoader from "../../components/LogoLoader/LogoLoader";
import PannelAccess from "./PannelAccess";
import { TbBrandWhatsapp, TbPigMoney } from "react-icons/tb";
import { FaPeopleGroup } from "react-icons/fa6";
import HowItWorks from "../../components/HowItWorks"

function Dashboard() {
  const { user } = useAuth();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [referrals, setReferrals] = useState([]);

  const shareOnWhatsApp = () => {
    const referralLink = `https://marketing.thewinnerindia.com/signup?ref=${userData.reference_code}`;
    const message = `Join me on Winner India! Sign up using my referral link: ${referralLink}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const response = await fetch(FETCH_Users, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ role: user.role }),
        });

        const data = await response.json();

        if (data.success) {
          const currentUser = data.users.find(
            (u) => u.phonenumber === user.phonenumber
          );

          if (currentUser) {
            setUserData(currentUser);

            // Fetch 1-level referrals
            const referralRes = await fetch(user_referral_level_one, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                reference_code: currentUser.reference_code,
              }),
            });

            const referralData = await referralRes.json();
            if (referralData.success) {
              setReferrals(referralData.referrals);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching user data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [user]);

  if (loading) return <LogoLoader />;
  if (!userData) return <div className="text-white text-center p-10">User data not found.</div>;

  return (
    <section className="bg-primary-100 min-h-screen pb-24">
      <PannelAccess>
        {/* Modern Profile Header */}
        <div className="mx-auto max-w-xl p-4">
          <div className="bg-primary rounded-3xl p-6 shadow-2xl relative overflow-hidden">
            {/* Background Accent */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-secondary opacity-10 rounded-full -mr-16 -mt-16 blur-2xl"></div>
            
            <div className="flex items-center gap-4 relative z-10">
              <div className="relative">
                <img
                  src={Dashboard_Profile}
                  alt="Profile"
                  className="w-16 h-16 rounded-2xl border-2 border-secondary p-0.5 shadow-lg"
                />
                <span className="absolute -bottom-1 -right-1 bg-green-500 w-4 h-4 rounded-full border-2 border-primary"></span>
              </div>
              
              <div className="flex-1">
                <h2 className="text-white font-bold text-lg leading-tight">
                  {userData.name}
                </h2>
                <p className="text-gray-400 text-xs font-medium">TWI_{userData.user_id}</p>
                <div className="flex gap-2 mt-1">
                  <span className="bg-secondary/20 text-secondary text-[10px] px-2 py-0.5 rounded-full font-bold">
                    PAID 300
                  </span>
                  <Link to="/settings" className="bg-white/10 text-gray-300 text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1">
                    {userData.allow_edit === "1" ? <IoLockOpen size={10} className="text-yellow-500" /> : <IoLockClosed size={10} className="text-red-500" />}
                    Bank Status
                  </Link>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-6 pt-4 border-t border-white/5">
              <div>
                <p className="text-gray-500 text-[10px] uppercase tracking-wider font-bold">Contact</p>
                <p className="text-white text-xs truncate">{userData.phonenumber}</p>
              </div>
              <div className="text-right">
                <p className="text-gray-500 text-[10px] uppercase tracking-wider font-bold">Joined</p>
                <p className="text-white text-xs">{userData.created_at.split(" ")[0]}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Marquee Info */}
        <div className="w-full bg-secondary/90 backdrop-blur-md text-primary overflow-hidden whitespace-nowrap py-1.5 shadow-sm">
          <div className="inline-block animate-marquee font-bold text-[13px] uppercase tracking-tight">
            Withdrawals will be Available daily • Minimum withdrawal amount ₹500 • Refer 3 users to unlock access
          </div>
        </div>

        {/* Quick Stats Grid */}
        <div className="max-w-xl mx-auto px-4 mt-4 grid grid-cols-3 gap-3">
          <div className="bg-primary p-3 rounded-2xl border border-white/5 shadow-lg text-center">
            <p className="text-gray-500 text-[10px] font-bold uppercase mb-1">Balance</p>
            <p className="text-secondary text-base font-black">₹{userData.digital_currency}</p>
          </div>
          <div className="bg-primary p-3 rounded-2xl border border-white/5 shadow-lg text-center flex flex-col items-center justify-center">
            <button
              onClick={shareOnWhatsApp}
              className="text-green-500 flex flex-col items-center"
            >
              <TbBrandWhatsapp size={20} />
              <span className="text-[10px] font-bold mt-1">SHARE</span>
            </button>
          </div>
          <div className="bg-primary p-3 rounded-2xl border border-white/5 shadow-lg text-center">
            <p className="text-gray-500 text-[10px] font-bold uppercase mb-1">Status</p>
            <p className="text-green-400 text-[11px] font-black uppercase">Active</p>
          </div>
        </div>

        {/* Highlight Stats */}
        <div className="max-w-xl mx-auto px-4 mt-4 grid grid-cols-2 gap-4">
          <div className="bg-secondary rounded-3xl p-5 shadow-xl relative overflow-hidden transition-transform active:scale-95">
            <FaPeopleGroup className="absolute -right-4 -bottom-4 text-primary/10 text-7xl rotate-12" />
            <h2 className="text-primary/60 text-[11px] font-black uppercase tracking-widest mb-1">Total Referrals</h2>
            <p className="text-primary text-3xl font-black">{userData.reference_total}</p>
            <p className="text-primary/60 text-[10px] mt-2 font-bold">Network Growth</p>
          </div>

          <div className="bg-secondary rounded-3xl p-5 shadow-xl relative overflow-hidden transition-transform active:scale-95">
            <TbPigMoney className="absolute -right-4 -bottom-4 text-primary/10 text-7xl -rotate-12" />
            <h2 className="text-primary/60 text-[11px] font-black uppercase tracking-widest mb-1">Total Reward</h2>
            <p className="text-primary text-3xl font-black">₹{userData.digital_currency}</p>
            <p className="text-primary/60 text-[10px] mt-2 font-bold">Total Earnings</p>
          </div>
        </div>

        {/* Referral Chains Section */}
        <div className="max-w-xl mx-auto mt-8 px-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-white font-bold text-base flex items-center gap-2">
              <span className="w-1 h-5 bg-secondary rounded-full"></span>
              Your Active Chains
            </h3>
            <span className="text-green-400 text-xs font-bold bg-green-400/10 px-2 py-1 rounded-lg">
              {referrals.filter((ref) => ref.pannel_access === "True").length}/3 Verified
            </span>
          </div>

          {referrals.length > 0 ? (
            <div className="grid grid-cols-3 gap-2">
              {referrals.slice(0, 3).map((ref, idx) => (
                <div
                  key={ref.user_id}
                  className="bg-primary p-2.5 rounded-2xl border border-white/5 shadow-lg relative overflow-hidden flex flex-col justify-between min-h-[110px]"
                >
                  <div className="absolute -top-1 -right-1 opacity-10">
                    <span className="text-3xl font-black text-white italic">{String.fromCharCode(65 + idx)}</span>
                  </div>
                  
                  <div>
                    <div className="flex items-center gap-1.5 mb-1.5">
                      <div className={`w-1.5 h-1.5 rounded-full ${ref.pannel_access === "True" ? "bg-green-500 shadow-[0_0_6px_rgba(34,197,94,0.6)]" : "bg-red-500"}`}></div>
                      <p className="text-gray-400 text-[12px] font-bold uppercase tracking-tight">Chain {String.fromCharCode(65 + idx)}</p>
                    </div>

                    <p className="text-white font-bold text-xs truncate mb-0.5">{ref.name}</p>
                    <p className="text-gray-500 text-[12px] font-medium truncate mb-2">{ref.phonenumber}</p>
                  </div>
                  
                  <div className="bg-white/5 p-2 rounded-xl text-center">
                    <p className="text-white text-[12px] font-bold uppercase leading-none mb-1">Total</p>
                    <p className="text-secondary font-black text-sm leading-none">{ref.reference_total}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-primary/50 rounded-2xl p-8 text-center border border-dashed border-white/10">
              <p className="text-gray-500 text-sm">No referrals found yet.</p>
              <button onClick={shareOnWhatsApp} className="text-secondary text-xs font-bold mt-2 hover:underline">Start Inviting Now</button>
            </div>
          )}
          
          <p className="text-gray-500 text-[10px] mt-4 text-center italic bg-white/5 py-2 rounded-lg">
            Tip: Maintain balanced chains (A=B=C) to unlock smooth withdrawals.
          </p>
        </div>

        <div className="max-w-xl mx-auto mt-8">
          <HowItWorks />
        </div>
      </PannelAccess>
    </section>
  );
}

export default Dashboard;
